import store from '@/store'

const { body } = document
const WIDTH = 850 // refer to Bootstrap's responsive design

export default {
  watch: {
  },
  beforeMount() {
    window.addEventListener('resize', this.$_resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeHandler)
  },
  mounted() {
  },
  methods: {
    // use $_ for mixins properties
    // https://vuejs.org/v2/style-guide/index.html#Private-property-names-essential
    $_resizeHandler() {
      if (!document.hidden) {
        const rect = body.getBoundingClientRect()
        if (rect.width - 1 < WIDTH) {
          store.dispatch('app/closeSideBar', { withoutAnimation: true })
        } else {
          store.dispatch('app/openSideBar', { withoutAnimation: true })
        }
      }
    }
  }
}
